import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

import { Container, Header, CircleRed, ConversationTopic, Payload, UserAndDateRow, UserInfo, DateInfo, StatusContainer, StatusText} from "./styles";

//Assets
import colors from "../../assets/css/colors";

//Interfaces
import { ConversationsPropsInterface } from "./interfaces";

const Conversations = (props: ConversationsPropsInterface) => {
    const [isNewConversation, setIsNewConversation] = useState(true);

    const chatWithNewMessageIdList = useSelector((state: {chatWithNewMessageIdList: any}) => state.chatWithNewMessageIdList);

    useEffect(() => {
        setIsNewConversation(chatWithNewMessageIdList.list.includes(props.id));
    }, [props.id, chatWithNewMessageIdList.list]);

    const getTopic = () => {
        if(props.topic.length > 38){
            return `${props.topic.slice(0, 38)}...`;
        } else {
            return props.topic;
        }
    }

    const colorStatusDefiner = () => {
        switch (props.status) {
            case "active":
                return {
                    bgColor: colors.redLight,
                    txtColor: colors.redDark
                }
            
            case "Resolvido":
                return {
                    bgColor: colors.greenLighter,
                    txtColor: colors.greenDarker
                }
            
            case "Encerrado":
                return {
                    bgColor: colors.primaryLighter,
                    txtColor: colors.primary
                }
            
            default: 
                return{
                    bgColor: colors.grayLightest,
                    txtColor: colors.grayDark
                }
        }
    }

    const textDefiner = (status: string) => {
        switch (status) {
            case "active":
                return "Não Resolvido";
            
            default:
                return "Indeterminado";
        }
    }

    const handleClickAtConversation = () => {
        setIsNewConversation(false);
    }

    const wasThisChatCreatedToday = () => {
        return moment(props.moment).isSame(moment(), "day");
    }
    
    return(
        <Container onClick={() => handleClickAtConversation()}>
            <Header isNew={isNewConversation}>
                {isNewConversation === true ? <CircleRed/> : null}
                <ConversationTopic>{getTopic()}</ConversationTopic>
            </Header>

            <Payload>
                <UserAndDateRow>
                    <UserInfo>{props.author}</UserInfo>
                    <DateInfo>{wasThisChatCreatedToday() ? moment(props.moment).format("hh:mm") : moment(props.moment).format("DD/MM/YYYY HH:mm")}</DateInfo>
                </UserAndDateRow>

                <StatusContainer color={colorStatusDefiner().bgColor}>
                    <StatusText color={colorStatusDefiner().txtColor}>
                        {textDefiner(props.status)}
                    </StatusText>
                </StatusContainer>
            </Payload>
        </Container>
    )
}

export default Conversations;